/* eslint-disable @typescript-eslint/no-explicit-any */
import Axios from 'axios';
import type { StatusType } from '@datadog/browser-logs';

const loggerDefaults = {
	service: 'aem-ui-components',
	version: import.meta.env.VITE_APP_VERSION as string
};

export function log(
	message: string,
	messageContext: Record<string, any>,
	status: StatusType,
	error?: unknown
) {
	// Add HTTP context to the log message if the error is an AxiosError
	if (error instanceof Axios.AxiosError) {
		// Add http object with content matching what Datadog sends itself on server errors
		messageContext = {
			...messageContext,
			http: {
				method: error.config?.method?.toUpperCase(),
				status_code: error.response?.status,
				url: (error.config?.baseURL ?? '') + error.config?.url
			},
			response: (error.response?.data as string) ?? 'No data'
		};
	}

	if (window.DD_LOGS && !Axios.isCancel(error)) {
		window.DD_LOGS?.logger.log(
			message,
			{
				...loggerDefaults,
				...messageContext
			},
			status,
			error instanceof Error ? error : undefined
		);
	} else {
		console.log(status, '>', message, messageContext, error);
	}
}

export function logError(message: string, messageContext: Record<string, any>, error?: unknown) {
	log(message, messageContext, 'error', error);
}

export function logWarn(message: string, messageContext: Record<string, any>, error?: unknown) {
	log(message, messageContext, 'warn', error);
}
